{
  "enum": {
    "IxcCasesV1CaseStatus": {
      "CLOSED": "Closed",
      "IN_PROGRESS": "In Progress",
      "OPEN": "Open",
      "RESOLVED": "Resolved",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcCasesV1CaseQueryServiceCaseListFilterableFields": {
      "caseId": "Case",
      "data": {
        "assignee": "Assignee"
      },
      "groupId": "Group ID",
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcCasesV1CaseEventType": {
      "closed": "Closed",
      "commented": "Commented",
      "created": "Created",
      "reassigned": "Reassigned",
      "resolved": "Resolved",
      "started": "Started"
    },
    "IxcCasesV1CaseUpdate": {
      "close": "Close",
      "comment": "Comment",
      "reassign": "Reassign",
      "resolve": "Resolve",
      "start": "Start"
    }
  },
  "searchEnum": {
    "IxcCasesV1CaseQueryServiceCaseListSearchableFields": {
      "data": {
        "description": "Description",
        "subject": {
          "fullName": "Full Name"
        },
        "title": "Title"
      }
    }
  },
  "sortEnum": {
    "IxcCasesV1CaseQueryServiceCaseListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}